module.exports = __webpack_public_path__ + "img/guardia.3ed0e3a4.png";